export default function getEventSlug(id: number, eventName: string) {
  return `${eventName}-${id}`.toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters except whitespace and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Remove consecutive hyphens
}
